const selectOrCreateControlTester = (uiSchema) => {
  return uiSchema.specializedType && uiSchema.specializedType === 'SelectOrCreate' ? 7 : 0
}

export default selectOrCreateControlTester